import { faPlay, faVolumeUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Howl } from 'howler'
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Fragment = ({fragment, index}) => {
    const {t: translate } = useTranslation();
    let lang = (fragment.language).toLowerCase();
    let audio = `${fragment.audioUrl}`;
    const [isPlaying, setIsPlaying] = useState(false);

    let sound = new Howl({
        src: [audio],
        html5: true,
        onplay: function() {
            setIsPlaying(true);
        },
        onend: function() {
            setIsPlaying(false)
        },
        onplayerror: function(id, err) {
            console.log(id)
            console.log(err)
        }
    });

    const playSound = () => {
        sound.play()
    }

    useEffect(() => {
      return () => {
        if( sound ) {
            sound.off() // Remove event listener
            sound.stop() // Stop playback
            sound.unload() // Remove sound from pool
            sound = null // Destroy it
        }
      }
    }, [])
    

    return (
        <div className="fragment-card" key={index}>
            <div className="fragment-card__actions" onClick={() => {playSound()}}>
                <FontAwesomeIcon icon={isPlaying ? faVolumeUp : faPlay} size="1x" />
            </div>
            <div className="fragment-card__content">
                <p className="fragment-card__learning">{fragment.learningLang}</p>
                <p className="fragment-card__native">{fragment.nativeLang}</p>
            </div>
            <img src={`/flags/${lang}.png`} className="fragment-card__flag" alt={translate(lang)} title={translate(lang)}/>
        </div>
    )
}

export default Fragment;